// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --market-qualtrics-head-font-size: 21px;
  --market-qualtrics-svg-height: 168px;
  --market-qualtrics-svg-width: 168px;
}

.market-qualtrics-slide {
  text-overflow: initial;
  white-space: normal;
  width: 925px;
}

.market-qualtrics-slide-head {
  font-size: var(--market-qualtrics-head-font-size);
}`, "",{"version":3,"sources":["webpack://./src/components/slides/market-qualtrics-slide/MarketQualtricsSlide.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iDAAiD;AACnD","sourcesContent":[":root {\n  --market-qualtrics-head-font-size: 21px;\n  --market-qualtrics-svg-height: 168px;\n  --market-qualtrics-svg-width: 168px;\n}\n\n.market-qualtrics-slide {\n  text-overflow: initial;\n  white-space: normal;\n  width: 925px;\n}\n\n.market-qualtrics-slide-head {\n  font-size: var(--market-qualtrics-head-font-size);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
